// productSlice.ts

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ProductState {
	selectedProduct: string | null;
}

const initialState: ProductState = {
	selectedProduct: "CTX Reflector",
};

const productSlice = createSlice({
	name: "product",
	initialState,
	reducers: {
		setSelectedProduct: (state, action: PayloadAction<string>) => {
			state.selectedProduct = action.payload;
		},
		clearSelectedProduct: (state) => {
			state.selectedProduct = null;
		},
	},
});

export const { setSelectedProduct, clearSelectedProduct } =
	productSlice.actions;
export default productSlice.reducer;
